import nlLocale from "element-ui/lib/locale/lang/nl";
const nl = {
  //Dutch 荷兰
  login: {
    buttoo: {
      add: "add",
    },
  },
  dialog: {
    buttton: {
      close: "Dichtbij",
    },
    ReportError: {
      next: "volgende",
      h1: "Met Report Error kunnen gebruikers met ons communiceren om eventuele dataproblemen op te lossen en de datakwaliteit te verbeteren.",
      li1: "Als u gegevensproblemen ondervindt of een vraag heeft over deze gegevens",
      li2: "Als u bedrijfsinformatie wilt bijdragen om deze gegevens te verbeteren",
      li3: "Als u ervoor kiest uw eigen bedrijfsinformatie die u mogelijk als privé beschouwt, niet openbaar te maken",
      li4: "Als u constructieve suggesties voor ons heeft om de dienstverlening te verbeteren",
      h2: "Alle ingediende opmerkingen zijn onderworpen aan gegevensverificatie. Gebruikers moeten uw eigen gebruikersprofiel invullen, aangezien onze vertegenwoordiger contact met u kan opnemen voor authenticatie en verificatie van uw bedrijf en eventuele rechten om uw bedrijf te vertegenwoordigen.",
      Iamanemployeeofthissubjectcompany:
        "Ik ben een werknemer van het betreffende bedrijf",
      Reportmycompany: "Meld mijn bedrijf",
      Updatedata: "Gegevens bijwerken",
      Reportinformationerrors: "Rapporteer informatiefouten",
      Reportotherscompany: "Rapporteer andere bedrijven",
      Financial: "Financieel",
      Pleaseprovidemoreinfo: "Geef alstublieft meer informatie.",
      Year: "Jaar",
      Business: "Bedrijf",
      Noofemployees: "Aantal werknemers",
      Coremanagement: "Kernmanagement",
      Corebusinessactivites: "Kernactiviteiten",
      IntBusiness: "Internationale zaken",
      Pleasedescribeyouractivites: "Beschrijf uw activiteiten.",
      Pleaselistcountriesyoudobusine:
        "Geef een lijst van de landen waar u zaken doet.",
      Corecompetency: "Kerncompetentie",
      Businessoutlook: "Zakelijke vooruitzichten",
      Uploadfiles: "Bestanden uploaden",
      Upload: "Uploaden",
      Cancel: "Annuleren",
      Submit: "Indienen",
      Select: "Selecteren",
      Selectthedatacategoryyoureport:
        "Selecteer de gegevenscategorie waarover u rapporteert.",
      TotalCurrentAssets: "Totale vlottende activa",
      CashBank: "Contanten en Bank",
      Accountreceivable: "Debiteuren",
      AdvancestoSuppliers: "Voorschotten aan leveranciers",
      Inventory: "Inventaris",
      Tobeappointedexpense: "Te benoemen kosten",
      Totalnoncurrentassets: "Totale vaste activa",
      Longterminvestment: "Langetermijninvestering",
      Fixedassetsnetvalue: "Netto waarde van de vaste activa",
      Projectsunderconstruction: "Projecten in aanbouw",
      Longtermtobeappointedexpenise:
        "Langdurige kosten die nog moeten worden vastgesteld",
      Deferredtaxdebit: "Uitgestelde belastingvordering",
      Totalcurrentliabilities: "Totale kortlopende schulden",
      Accountpayable: "Crediteuren",
      Advancesfromclients: "Voorschotten van klanten",
      Salariespayable: "Salarissen betaalbaar",
      Taxespayable: "Te betalen belastingen",
      Otheraccountspayable: "Overige crediteuren",
      Totalequity: "Totale eigen vermogen",
      Paidupcapital: "Gestort kapitaal",
      Capitalreserves: "Kapitaalreserves",
      Surplusreserves: "Overschotreserves",
      Undistrbutedporfit: "Niet-uitgedeelde winst",
      Totalassets: "Totale activa",
      Turnover: "Afzet",
      Costofgoodssold: "Kosten van verkochte goederen",
      Salestax: "Omzetbelasting",
      Grossprofit: "Brutowinst",
      Otheroperatingprofils: "Andere operationele profielen",
      Salesexpense: "Verkoopkosten",
      Managementexpense: "Beheerkosten",
      Financeexpense: "Financiële kosten",
      Operatingprofit: "Bedrijfswinst",
      Nonoperatingincome: "Niet-operationele inkomsten",
      Profitbeforetax: "Winst vóór belasting",
      Incometax: "Inkomstenbelasting",
      Netincome: "Netto-inkomen",
      DataProblems: "Gegevensproblemen",
      CorrectInformation: "Correcte informatie",
    },
  },
  Home: {
    Applications: "Toepassingen",
    SearchCompanies: "Bedrijven zoeken",
    SearchLeads: "Zoek leads",
    SearchTrade: "Zoek handel",
    SearchSanctions: "Sancties zoeken",
    SearchNews: "Zoek Nieuws",
    RiskScan: "Risicoscan",
    SearchRelationship: "Relatie zoeken",
    DataServices: "Datadiensten",
    SearchCountries: "Zoek landen",
    selectCountry: "Selecteer land",
    Entercompanyname: "Bedrijfsnaam invoeren",
    keWord: "Trefwoord",
    firstWord: "Precies links",
    search: "Zoeken",
    homeSeachTitle: "Wereldwijd zakendoen in beeld",
    homeTitleDetail:
      "CSI, een datagedreven onderzoeks- en IT-bureau, is gespecialiseerd in krediet, risico en big data. Het biedt digitale tools aan wereldwijde investeerders en zakelijke professionals, waarbij geavanceerde analyses en algoritmen worden gebruikt om snelle, visuele inzichten te bieden die slimmere besluitvorming mogelijk maken.",
    phoneTitleDetail:
      "Om snel bedrijfsinformatie te zoeken, bekijken en verkrijgen, kunt u ook de CSI-app op uw telefoon gebruiken",
    searchCompanyNum:
      "Zoek meer dan 500 miljoen bedrijven in meer dan 200 landen en gebieden",
    newsHeadTitle:
      "Ontdek de strategische inzichten achter elk bedrijfsnieuwsbericht.",
    sanctionHeadTitle:
      "Handel vol vertrouwen in de internationale handel door bedrijven en producten te screenen op naleving van wereldwijde sancties",
    tradeHeadTitle:
      "Transformeer wereldwijde handelsgegevens in strategische marktinzichten",
    relationshipTitle:
      "Ultiem eigendom en controle / Investeringsvoetafdruk / Supply chain-netwerk / Gestroomlijnde naleving / Risicobeperking / Wereldwijde dekking",
    IndustryAnalysis: "Industrie Analyse",
    BusinessAnalytics: "Bedrijfsanalyse",
    ImportExportData: "Import-exportgegevens",
    CompanyNews: "Bedrijfsnieuws",
    Sanctions: "Sancties",
    BusinessIntelligence: "Bedrijfsinformatie",
    CompanyIdentityVerification: "Verificatie van bedrijfsidentiteit",
    KYCSolutions: "KYC-oplossingen",
    OwnershipPenetration: "Eigendomspenetratie",
    CompanyFinancialAnalysis: "Financiële analyse van het bedrijf",
    CreditRatings: "Kredietbeoordelingen",
    CreditReports: "Kredietrapporten",
    ESGRatings: "ESG-beoordelingen",
    VendorScreening: "Leveranciersscreening",
    MarketResearch: "Marktonderzoek",
    EnterKeyword: "Voer trefwoord in",
    Country: "Land",
    Company: "Bedrijf",
    Person: "Persoon",
    Product: "Product",
    EnterPersonName: "Voer de naam van de persoon in",
    EnterCountryName: "Voer de landnaam in",
    EnterproductName: "Voer producttrefwoorden in",
    EnterproductNamekeywordsorHSCode: "Voer product trefwoorden of HS-code in",
    Searchby: "Zoeken op",
    SICStandardIndustryCode: "SIC - Standaard industriecode",
    HSCodeHarmonizedSystemCode: "HS-code - Geharmoniseerde systeemcode",
    AIAssistance: "AI-ondersteuning",
    EnterISICNACENAICSCSICAAAICGICS:
      "Voer ISIC / NACE / NAICS / CSIC / AAAIC / GICS in",
    EnterHarmonizedSystemCode: "Voer de geharmoniseerde systeemcode in",
    SIC: "SIC",
    HSCode: "HSCode",
    Tips:"Tips",
    detailconttext:
      "De functie die u probeert te gebruiken, maakt deel uit van de voordelen van ons premium lidmaatschap. Om toegang te krijgen tot deze functie en optimaal te profiteren van alle premium functies, dient u zich te abonneren op ons lidmaatschap.",
    Subscribe: "Abonneren",
  },
  Toolbar: {
    Filter: "Filter",
    Select: "Selecteren",
    Edit: "Bewerken",
    Sortby: "Sorteren op",
    Collect: "Verzamelen",
    Saved: "Opgeslagen",
    Compare: "Vergelijken",
    Export: "Exporteren",
    Download: "Downloaden",
    Update: "Bijwerken",
    Reporterror: "Fout melden",
    Share: "Delen",
    ascending: "oplopend",
    descending: "aflopend",
    Yourfolder: "Uw map",
    RiskScanning: "Risicoscan",
    CreditAssessment: "Kredietbeoordeling",
    DataAnalysis: "Gegevensanalyse",
    NewPortfolio: "Nieuw portfolio",
    Print: "Afdrukken",
    Optimize: "Optimaliseren",
    ALL: "Alles",
    Confirm: "Bevestig",
  },
  Export: {
    Choosethedatafields: "Selecteer de gegevensvelden die u wilt exporteren.",
    Enterkeywords: "Voer trefwoord in",
    Financialdata: "Financiële gegevens",
    Reset: "Reset",
    Back: "Rug",
    Howmanyresults:
      "Hoeveel resultaten wilt u exporteren vanuit deze zoekopdracht? U kunt uw zoekopdracht ook verfijnen door extra filters toe te voegen.",
    FileName: "Bestandsnaam",
    Pleaseenterafilename: "Voer een bestandsnaam in",
    SelectedList: "Geselecteerde lijst",
  },
  AiZaba: {
    whatareyousearchingfor: "waar ben je naar op zoek",
    CreditAnalyst: "Kredietanalist",
    Assesses:
      "Beoordeelt de kredietwaardigheid van een bedrijf, identificeert financiële risico's en zorgt voor veilige transacties door middel van data-analyse en kredietbeoordelingen.",
    LegalAdvisor: "Juridisch adviseur",
    Provides:
      "Biedt nalevingsbegeleiding, beoordeelt contracten en beoordeelt juridische risico's om ervoor te zorgen dat de bedrijfsvoering in overeenstemming is met de wetgeving en geschillen te voorkomen.",
    BizConsultant: "Biz-consulent",
    Optimizes:
      "Optimaliseert toeleveringsketens, identificeert kopers en verhoogt de verkoop door markttrends te analyseren en op maat gemaakte strategieën aan te bieden om de efficiëntie te verbeteren.",
    EconomicAnalyst: "Economisch analist",
    Analyzes:
      "Analyseert industriële en regionale economische trends en helpt bedrijven nemen weloverwogen beslissingen en blijven concurrerend.",
    HiImZabaYourresearchassistant:
      "Hallo, ik ben Zaba - uw onderzoeksassistent",
  },
  navigationBar: {
    Notifications: "Meldingen", //通知
    MarkasRead: "Markeren als gelezen", //标记已读
    Viewall: "Alles bekijken", //查看全部
    SilverSubscriber: "Zilveren abonnee", //银级用户
    GoldSubscriber: "Gouden abonnee", //金级用户
    SubscriptionExpires: "Abonnement verloopt", //未对应
    AvailableCredits: "Beschikbare credits", //可用积分
    AddCredits: "Credits toevoegen", //购买积分
    IndivdualAccount: "Individueel account", //个人账号
    GroupAccount: "Groepsaccount", //集团账号
    UserAccount: "Gebruikersaccount",
    Roles: "Functies", //角色
    Thereiscurrentlynonewnews: "Er is momenteel geen nieuw nieuws",
    EnterTitleContent:"Voer titelinhoud in",
  },
  ListofResults: {
    Country: "Land",
    Industry: "Branche",
    CompanyType: "Bedrijfstype",
    CompanySize: "Bedrijfsgrootte",
    CompanyStatus: "Bedrijfsstatus",
    CompanyName: "Bedrijfsnaam",
    RegStatus: "Reg. status",
    StateProvince: "Staat/Provincie",
    CityCounty: "Plaats/County",
    DistrictCity: "District/Stad",
    IncDate: "Inc. datum",
    LegalForm: "Rechtsvorm",
    CoID: "Bedrijfsnummer",
    TaxNo: "Btw-nummer",
    ListingInfo: "Vermeldingsgegevens",
    Phone: "Telefoon",
    Website: "Website",
    Email: "E-mail",
    LegalPerson: "Rechtspersoon",
    PostCode: "Postcode",
    ISIC: "ISIC",
    IndustryDescription: "Bedrijfsomschrijving",
    NACE: "NACE",
    NAICS: "NAICS",
    CreditRating: "Kredietbeoordeling",
    SolvencyIndex: "Solvabiliteitsindex",
    ProbabilityofDefault: "Kans op wanbetaling",
    NoofEmployees: "Aantal werknemers",
    Revenue: "Omzet",
    TotalAsset: "Totale activa",
    NetProfit: "Nettowinst",
    ROA: "ROA",
    ROE: "ROE",
    ShowMore: "Meer weergeven",
    SelectCountry: "Selecteer Land",
    ClearAll: "Alles wissen",
    SelectIndustry: "Selecteer Industrie",
    ListedCompany: "Beursgenoteerd bedrijf",
    YearsinBusiness: "Jaren in het bedrijfsleven",
    Sharethisinformation: "Deel deze informatie",
    Pleaseaddress: "Voer een of meer e-mailadressen in",
    Example: "Voorbeeld",
    message: "bericht",
    pleaseleaveamessage: "laat dan een bericht achter",
    Include: "Inclusief",
    thisaddress: "deze bedrijfsnaam, ID, adres",
    CSIwebsite: "CSI-website",
    Update: "Bijwerken",
    Iftheavailable:
      "Als de beschikbare online gegevens onvoldoende of verouderd zijn, kunt u op de knop 'Bijwerken' klikken om onmiddellijk een update aan te vragen voor een nieuw onderzocht bedrijfskredietrapport van onze lokale netwerkonderzoekers of kredietinformatiebureaus. De kosten voor deze update bedragen 1 credit per bedrijf. Het duurt doorgaans tussen de 24 en 72 uur voordat het updaterapport wordt afgeleverd.",
    Abusinesscredit:
      "Een zakelijk kredietrapport biedt gedetailleerde informatie over de identificatiegegevens van het betreffende bedrijf, registergegevens, aandeelhoudersstructuur, bedrijfsgeschiedenis, managementbeschrijving, gerelateerde bedrijven, feitelijke activiteiten, handelsreferenties, financiële gegevens en analyses, officiële openbare informatie zoals processtukken en sancties, en kredietanalyse en -beoordeling.",
    Searchcompanies: "Zoek meer e-mails van andere bedrijven",
    Rowsperpage: "Rijen per pagina",
    Remove: "Verwijderen",
    Confirm: "Bevestig",
  },
  ContentTabs: {
    Background: "Achtergrond",
    BusinessActivities: "Bedrijfsactiviteiten",
    Performance: "Prestaties",
    Publications: "Publicaties",
    CreditOpinion: "Kredietoordeel",
    MarketAnalysis: "Marktanalyse",
    Snapshot: "Snapshot",
    Profile: "Profiel",
    Ownership: "Eigendom",
    RelatedCompanies: "Gerelateerde bedrijven",
    Management: "Management",
    Operations: "Operations",
    Locations: "Locaties",
    Industry: "Branche",
    ImportExport: "Import & Export",
    SupplyChain: "Toeleveringsketen",
    FinancialHighlights: "Financiële hoogtepunten",
    RatioAnalysis: "Ratioanalyse",
    IndustryNorm: "Branchenorm",
    News: "Nieuws",
    Sanctions: "Sancties",
    IndustryStatistics: "Branchestatistieken",
    RatingAnalysis: "Ratinganalyse",
    CompetitiveAnalysis: "Concurrentieanalyse",
  },
  Snapshot: {
    CompanyDQIdesc1:
      "De Data Quality Index (DQI) maakt gebruik van algoritmen om verschillende aspecten van gegevens te beoordelen, waaronder volledigheid, validiteit, betrouwbaarheid van bronnen, consistentie, tijdigheid en tweetalige ondersteuning.",
    CompanyDQIdesc2:
      "De index is ontworpen om de kwaliteit van gegevens te beoordelen op een schaal van 1 tot 100, waarbij hogere scores een superieure gegevenskwaliteit aangeven. Algoritmen kunnen gegevens analyseren op basis van vooraf gedefinieerde regels of criteria, waardoor objectieve en gestandaardiseerde metingen mogelijk zijn.",
    CompanyDQIdesc3:
      "Onze Data Quality Index (DQI) dient als een betrouwbare indicator waarmee gebruikers de datakwaliteit kwantitatief kunnen beoordelen. Dit maakt datagestuurde besluitvorming mogelijk en verbetert de algehele waarde en bruikbaarheid van de data.",
    CountryDQIdesc1:
      "De Data Quality Index (DQI) beoordeelt de betrouwbaarheid, nauwkeurigheid en toegankelijkheid van gegevens tussen landen, en weerspiegelt verschillen in digitale infrastructuur, bestuur en transparantie. Ontwikkelde landen staan doorgaans hoger op de ranglijst vanwege sterke datasystemen, open beleid en geavanceerde technologie, terwijl ontwikkelingseconomieën vaak worstelen met hiaten in de infrastructuur, regelgeving of praktijken voor het delen van gegevens.",
    CountryDQIdesc2:
      "Belangrijke factoren zijn onder meer transparantie van de overheid, wetgeving inzake gegevensbescherming en technologische adoptie. Een hoge DQI maakt betere beleidsvorming en zakelijke beslissingen mogelijk, terwijl een lage score gebieden benadrukt die investeringen behoeven.",
    CompanyDQI: "Bedrijfs-DQI", //公司数据质量指数 DQI
    CountryDQI: "Land-DQI", //国家数据质量指数 DQI
    CompanyTitle: "Datakwaliteitsindex (DQI) per bedrijf",
    CountryTitle: "Datakwaliteitsindex (DQI) per land",
    Address: "Adres", //地址
    CountyCity: "Graafschap/Stad", //县/市
    ProvinceState: "Provincie/Staat", //省/州
    CountryRegion: "Land/Regio", //国家/地区
    ZipCode: "Postcode", //邮政编码
    Website: "Website", //网站
    Email: "E-mail", //电邮
    Tel: "Tel.", //电话
    LastUpdate: "Laatste update", //最近更新
    DataSource: "Gegevensbron", //数据来源
    LegalStatus: "Rechtsstatus", //法定状况
    CoID: "Bedrijfs-ID", //公司ID
    CompanyType: "Bedrijfstype", //公司类型
    RegistrationDate: "Registratiedatum", //注册日期
    RegistrationStatus: "Registratiestatus", //注册状态
    Listed: "Geregistreerd", //上市信息
    CurrentOpperations: "Huidige activiteiten", //经营状况
    IndustryCode: "Branchecode", //行业代码
    BusinessActivities: "Bedrijfsactiviteiten", //主营业务
    NoofEmployees: "Aantal medewerkers", //员工数量
    NoofShareholders: "Aantal aandeelhouders", //股东数量
    Management: "Management", //管理状况
    Performance: "Prestaties", //业绩表现
    Revenue: "Omzet", //收入
    Assets: "Activa", //资产
    ProfitLoss: "Winst/verlies", //利润
    Growth: "Groei", //公司增长
    Competitiveness: "Concurrentievermogen", //竞争力
    CreditOpinion: "Kredietoordeel", //信用状况
    CreditRating: "Kredietbeoordeling", //信用评级
    CreditScore: "Kredietscore", //信用评分
    ESGRating: "ESG-beoordeling", //ESG 评级
    Solvency: "Solvabiliteit", //偿还能力
    Sanctions: "Sancties", //全球制裁
    CoName: "Bedrijfsnaam",
    RegName: "Geregistreerde naam",
  },
  Profile: {
    CompareCompanies: "Vergelijk bedrijven",
    AddaCompany: "Voeg een bedrijf toe",
    SubjectCompany: "Onderwerpbedrijf", //目标公司
    ComparisonCompany: "Vergelijkingsbedrijf",
    CompanyProfile: "Bedrijfsprofiel", //基本资料
    CompanyName: "Bedrijfsnaam", //公司名称
    NativeName: "Oorspronkelijke naam", //当地名称
    CompanyID: "Bedrijfs-ID", //公司 ID
    VATNumber: "Btw-nummer", //VAT号
    StockCode: "Aandelencode", //股票代码
    Listed: "Geregistreerd", //上市日期
    RegistrationDate: "Registratiedatum", //注册日期
    LegalForm: "Rechtsvorm", //公司性质
    CompanyType: "Bedrijfstype", //公司类型
    LegalStatus: "Rechtsstatus", //注册状态
    Jurisdiction: "Jurisdictie", //司法管辖区
    RegisteredAddress: "Geregistreerd adres", //注册地址
    ProvinceState: "Provincie/Staat", //省/州
    CountryRegion: "Land/Regio", //国家/地区
    ZipCode: "Postcode", //邮政编码
    OperatingAddress: "Bedrijfsadres", //经营地址
    LastUpdate: "Laatste update", //最近更新
    DataSource: "Gegevensbron", //数据来源
    History: "Geschiedenis", //历史记录
    RegisteredCapital: "Geregistreerd kapitaal",
    PaidinCapital: "Gestort kapitaal",
    CountyCity: "Provincie/Staat",
    OtherName: "Andere naam",
  },
  Ownership: {
    TotalPartiesInvolved: "Totaal aantal betrokken partijen",
    UltimateBeneficiaryOwner: "Uiteindelijk begunstigde (UBO)", //最终受益人
    NaturalPersonShareholder: "Natuurlijk persoon aandeelhouder", //涉及自然人股东
    CorporateShareholders: "Bedrijfsaandeelhouders", //涉及法人股东
    ShareholderLevel: "Aandeelhoudersniveau", //股东层级x
    Name: "Naam", //名称
    Country: "Land", //国家/地区
    Location: "Locatie", //地点
    Type: "Type", //类型
    Shares: "Aandelen", //股份
    Relation: "Relatie", //关系
    RelatedCompany: "Gerelateerde bedrijven",
    CompanyShareholders: "Aandeelhouders van het bedrijf",
    NGOShareholders: "NGO-aandeelhouders",
    SubjectInvestments: "Investeringen van het onderwerp",
  },
  RelatedCompanies: {
    Total: "Totale entiteiten", //相关公司总计
    Countries: "Landen", //国家/地区
    Branches: "Vestigingen", //分支机构
    RelatedComp: "Gerelateerde bedrijven", //关联公司
    Name: "Naam", //名称
    Country: "Land", //国家/地区
    Location: "Locatie", //地点
    Type: "Type", //类型
    Relationship: "Relatie", //关系
    BranchOffices: "Bijkantoren",
    Subsidiaries: "Dochterondernemingen",
  },
  Management: {
    Management: "Management", //管理层
    ContactInfo: "Contactgegevens", //联系人信息
    Countries: "Landen", //国家/地区
    Name: "Naam", //名称
    Position: "Functie", //职位
    Department: "Afdeling", //部门
    Country: "Land", //国家/地区
    ShareholderNot: "Aandeelhouder of niet", //是否股东
    Relation: "Relaties", //关系
    Verification: "Verificatie", //已验证
    Searchmoreemails: "Zoek meer e-mails", //搜索更多电邮
    Roles: "Functies", //角色
    EducationLevel: "Opleidingsniveau", //教育程度
    Phone: "Telefoon", //电话
    Email: "E-mail", //电邮
    Verified: "Geverifieerd", //已验证
    Searchmore: "Zoek meer e-mails van andere bedrijven", //搜索更多其他公司的电邮
    Pleaseentername: "Voer een naam in",
    PleaseenterWebsite: "Voer de bedrijfsnaam of het domein in",
    UserSelfVerification: "Zelfverificatie van gebruiker",
    Userverified: "Gebruiker geverifieerd",
    Source: "Bron",
  },
  Operations: {
    LineofBusiness: "Bedrijfstak", //业务范围
    BusinessTerritories: "Zakelijke gebieden", //业务区域
    ImportExport: "Import & Export", //进出口信息
    Viewtradeinfo: "Bekijk meer handelsinformatie", //查看更多贸易信息
    ProductsServices: "Producten/Diensten", //产品/服务
    Products: "Producten", //产品
    ProductImage: "Productafbeelding", //产品图片
    ProductName: "Productnaam", //产品名称
    ProductDescription: "Productomschrijving", //产品描述
    Details: "Details", //详情
    Addproductinformation: "Productinformatie toevoegen", //添加产品信息
    Showcaseyourcompany:
      "Als u de producten of diensten van uw bedrijf aan het publiek wilt presenteren, kunt u hier uw product- en service-informatie toevoegen. Dit is een geweldige manier om uw bedrijf te promoten. Zodra we uw inzending hebben beoordeeld, worden uw gegevens gepubliceerd.",
  },
  Locations: {
    CoName: "Bedrijfsnaam", //业务范围
    Relationship: "Relatie", //关系
    Type: "Type", //类型
    Country: "Land", //国家/地区
    Location: "Locatie", //地点
    Address: "Adres", //地址
    Edit: "Bewerken", //编辑
    CompanyLocatiionsMap: "Bedrijfslocaties op de kaart", //地图中的公司位置
    Selectaddresstype: "Adrestype selecteren", //选择地址类型
    Subjectcompany: "Onderwerp bedrijf", //目标公司
    Subsidiary: "Dochteronderneming", //子公司
    RegisteredAddress: "Geregistreerd adres", //注册地址
    OperationAddress: "Bedrijfsadres", //运营地址
    All: "Alles", //全部
    Showlocation: "Toon locaties",
  },
  Industry: {
    IndustryTitle: "Branchetitel", //IndustryTitle
    IndustryDescription: "Branchebeschrijving", //IndustryDescription
    ISIC: "ISIC", //ISIC
    ISICDescription: "ISIC-beschrijving", //ISICDescription
    NACE: "NACE", //NACEDescription
    NACEDescription: "NACE-beschrijving", //NACEDescription
    NAICS: "NAICS", //NAICS
    NAICSDescription: "NAICS-beschrijving", //NAICSDescription
    CSIC: "CSIC", //CSIC,
    CSICDescription: "CSIC-beschrijving", //CSICDescription
    AAAIC: "AAAIC", //AAAIC
    AAAICDescription: "AAAIC-beschrijving", //AAAICDescription
    GICS: "GICS", //GICS
    GICSDescriptio: "GICS-beschrijving", //GICS 描述
  },
  ImportExport: {
    TotalImportAmount: "Totaal importbedrag", //进口总额
    TopImportCountry: "Top importland", //最大进口国家/地区
    TopImportProduct: "Top importproduct", //最大进口产品
    TotalExport: "Totaal exportbedrag", //出口总额
    TopExportCountry: "Top exportland", //最大出口国家/地区
    TopExportProduct: "Top exportproduct", //最大出口产品
    TradeVolume: "Handelsvolume", //贸易额
    ImportShipments: "Importzendingen", //进口量
    ExportShipments: "Exportzendingen", //出口量
    ImportCountries: "Importlandens", //进口国家/地区
    ExportCountries: "Exportlanden", //出口国家/地区
    ImportVolume: "Importvolume", //进口量
    ExportVolume: "Exportvolume", //出口量
    Suppliers: "Topleveranciers", //主要供应商
    Shipments: "Op aantal zendingen", //按出货量
    Buyers: "Topkopers", //主要买家
    ImportQuantity: "Importhoeveelheid", //进口数量
    IncreaseDecreasexRate: "Toename-/afnamepercentage", //增/减率
    ExportQuantity: "Exporthoeveelheid", //出口数量
    ImportsExportsRecords: "Import- en exportrecords", //进出口记录
    Date: "Datum", //日期
    Product: "Product", //产品
    HSCode: "HS-code", //HS 编码
    BuyerName: "Naam koper", //买家名称
    Destination: "Bestemming", //目的地
    SupplierName: "Naam leverancier", //供应商名称
    Origin: "Oorsprong", //原产地
    Amount: "Hoeveelheid (USD)", //金额
    Details: "Details", //详情
    Imports: "Importeert",
    Exports: "Exporteren",
    Shipments2: "Zendingen",
    value2: "waarde",
    value: "bekijk meer handelsinformatie",
    viewmoretradeinfo: "bekijk meer handelsinformatie",
    SearchHSCode: "Zoek HS-code",
    Selectdate: "Selecteer datum",
  },
  SupplyChain: {
    Illustratesthesubjectcompany:
      "Dit diagram illustreert de ‘koop van’- en ‘verkoop aan’-relaties van het betreffende bedrijf. Hoe groter het volume, hoe dikker de buis.",
  },
  ShippingOrderDetails: {
    Date: "Datum",
    MasterBillofLading: "Hoofdvrachtbrief",
    Source: "Bron",
    BillNo: "Factuurnummer",
    ImporterBuyer: "Importeur/koper",
    ExporterSeller: "Exporteur/verkoper",
    Name: "Naam",
    Address: "Adres",
    Country: "Land",
    Contact: "Contactpersoon",
    Email: "E-mailadres",
    CargoInfo: "Ladinginformatie",
    HSCode: "HS-code",
    Quantity: "Aantal",
    WeightUnit: "Gewichtseenheid",
    ProductDescription: "Productomschrijving",
    Amount: "Hoeveelheid (USD)",
    QuantityUnit: "Hoeveelheidseenheid",
    Weight: "Gewicht",
    HSDescription: "HS-omschrijving",
    Incoterms: "Incoterms",
    ShippingInfo: "Verzendinformatie",
    Vessel: "Schip",
    Consignee: "Geadresseerde",
    MeansofTransport: "Vervoermiddel",
    CountryofOrigin: "Land van herkomst",
    Voyage: "Reis",
    Notifier: "Kennisgever",
    CountryofDestnation: "Land van bestemming",
    AddressofOrigin: "Adres van herkomst",
    Shipper: "Verzender",
    AddressofDestnation: "Adres van bestemming",
    Container: "Container",
    ContainerID: "Container-ID",
    ContainerType: "Containertype",
    ContainerDescDode: "Containeromschrijving",
    ContainerSize: "Containergrootte",
    ImportExport: "Importeur / Exporteur",
    Imports: "Importeert",
    Exports: "Exporteren",
  },
  FinancialHighlight: {
    Revenue: "Omzet", //收入
    Profit: "Winst", //利润
    Growth: "Groei", //增长
    CashFlowStatus: "Kasstroomstatus", //现金流状况
    FinancialStructure: "Financiële structuur", //融资结构
    CreditOpinion: "Kredietoordeel", //信用评估
    RiskIndicator: "Risico-indicator", //风险指标
    Solvencyindex: "Solvabiliteitsindex", //偿还指数
    Year: "Jaar", //年份
    Change: "Verandering", //变化
    NetProfit: "Nettowinst",
    TotalAssets: "Totale activa",
    Equity: "Eigen vermogen",
    GrossMargin: "Brutomarge",
    ProfitMargin: "Winstmarge",
    ReturnonEquity: "Rendement op eigen vermogen",
    CurrentRatio: "Current ratio",
    DebtRatio: "Schuldratio",
    FinancialHighlights: "Financiële gegevens van de gerelateerde bedrijven", //关联公司财务数据
    FinancialHighlightsTitle:
      "Financiële hoogtepunten van de gerelateerde bedrijven", //关联公司财务摘要
    CompanyName: "Bedrijfsnaam", //公司名称
    CompanyID: "Bedrijfs-ID", //公司ID
    Country: "Land", //国家/地区
    CompanyStatus: "Bedrijfsstatus", //公司状态
    Cancel: "Annuleren", //取消
    Select: "Selecteren",
    Relations: "Relaties", //关系
    Financialperformancedata:
      "Gegevens over financiële prestaties worden verzameld uit verschillende overheidsbronnen en lokale kredietinformatiebureaus. Daarnaast wordt markt- en sectoronderzoek gebruikt om de gegevens te berekenen en te modelleren. Voor meer gedetailleerde informatie over de daadwerkelijke bedrijfsvoering en prestatieanalyse kunt u contact opnemen met ons serviceteam om een ​​bedrijfsdue diligence-rapport aan te vragen.",
    Whenthesubjectsdata:
      "Als de gegevens van het onderwerp onvoldoende zijn, of als u meer inzicht wilt krijgen in uw klant, biedt dit platform een uitgebreid overzicht van alle entiteiten die verband houden met het onderwerp. Dit omvat de aandeelhouders van het bedrijf van het onderwerp, gerelateerde bedrijven en meer.",
    Byprovidingyou:
      "Door u een breder perspectief te bieden, stelt dit platform u in staat beter geïnformeerde evaluaties te maken en een dieper inzicht in uw onderwerp te krijgen.",
    PleaseSelectTheYeartoDisplay: "Selecteer het jaar dat u wilt weergeven",
    SelectUptoThreeYears: "Selecteer Maximaal drie jaar",
  },
  RatioAnalysis: {
    ProfitabilityRatios: "Winstgevendheidsratio's",
    Year: "Jaar",
    Change: "Verandering",
    Returnonequity: "Rendement op eigen vermogen",
    Returnonassets: "Rendement op activa",
    Profitmargin: "Winstmarge",
    Grossmargin: "Brutomarge",
    OperatingRatios: "Operationele ratio's",
    Assetsturnover: "Omloopsnelheid activa",
    Stockturnover: "Omloopsnelheid voorraad",
    Salesperiod: "Verkoopperiode",
    Collectionperiod: "Incassoperiode",
    Creditperiod: "Kredietperiode",
    StructuralRatios: "Structurele ratio's",
    Currentratio: "Huidige verhouding",
    Quickratio: "Snelle ratio",
    Shareholdersliquidityratio: "Liquiditeitsratio aandeelhouders",
    Solvencyratio: "Solvabiliteitsratio",
    Debtratio: "Schuldratio",
    ProductivityRatios: "Productiviteitsratio's",
    Profitperemployee: "Winst per werknemer",
    Operatingrevenueperemployee: "Bedrijfsopbrengsten per werknemer",
    Shareholdersfundsperemployee: "Eigen vermogen per werknemer",
    Totalassetsperemployee: "Totale activa per werknemer",
    GrowthRatios: "Groeiratio's",
    Salesgrowthrate: "Omzetgroei",
    Netprofitgrowthrate: "Groei van de nettowinst",
    Totalassetsgrowthrate: "Groei van de totale activa",
    FinancialHighlights: "Financiële gegevens van de gerelateerde bedrijven", //关联公司财务数据
    RatioAnalysis: "Ratioanalyse van de gerelateerde bedrijven", //关联公司比率分析
    CompanyName: "Bedrijfsnaam",
    CompanyID: "Bedrijfs-ID",
    Country: "Land",
    CompanyStatus: "Bedrijfsstatus",
    Relations: "Relaties",
  },
  IndustryNorms: {
    IndustryStatistics: "Branchestatistieken",
    ofcompaniesintheIndustry: "Aantal bedrijven in de branche",
    oflistedCompaniesintheIndustry:
      "Aantal beursgenoteerde bedrijven in de branche",
    oflargecompaniesintheIndustry: "Aantal grote bedrijven in de branche",
    ofSMEsintheIndustry: "Aantal mkb-bedrijven in de branche",
    ofcompaniesinsample: "Aantal bedrijven in de steekproef",
    ofcompaniesinloss: "Aantal bedrijven met verlies",
    Observations: "Observaties",
    AverageValue: "Gemiddelde waarde",
    MedianValue: "Mediaanwaarde",
    MaximumValue10: "Maximale waarde 10%",
    MinimumValue10: "Minimale waarde 10%",
    SubjectCompany: "Onderwerp",
    YearsinBusiness: "Bedrijfsjaren",
    TotalAssets: "Totale activa",
    TotalEquity: "Totaal eigen vermogen",
    Revenue: "Omzet",
    NetEarning: "Nettowinst",
    Returnonassets: "Rendement op activa",
    Performance: "Prestaties",
    ProfitabilityRatios: "Winstgevendheidsratio's",
    Returnonequity: "Rendement op eigen vermogen",
    Grossmargin: "Brutomarge",
    OperatingRatios: "Operationele ratio's",
    Stockturnover: "Omloopsnelheid van de voorraad",
    Accountsreceivableturnover: "Omloopsnelheid van debiteuren",
    Assetsturnover: "Omloopsnelheid van activa",
    Totalassetturnover: "Omloopsnelheid van totale activa",
    StructuralRatios: "Structuurratio's",
    Currentratio: "Huidige verhouding",
    Quickratio: "Snelle ratio",
    Shareholdersliquidityratio: "Liquiditeitsratio aandeelhouders",
    GrowthRatios: "Groeiratio's",
    Salesgrowthrate: "Omzetgroei",
    Netprofitgrowthrate: "Groeisnelheid van de nettowinst",
    Totalassetsgrowthrate: "Groeisnelheid van totale activa",
  },
  Lawsutis: {
    Litigations: "rechtszaken",
    Date: "Datum",
    CaseType: "Casetype",
    Title: "Zaaktitel",
    CaseNo: "Zaak nr.",
    CauseofAction: "Oorzaak van actie",
  },
  News: {
    Date: "Datum", //日期
    Title: "Titel", //标题
    Source: "Bron", //来源
    Impact: "Impact", //影响
    Searchcompanies: "Zoek meer nieuws over andere bedrijven", //国家/地区
    SearchforTitle: "Zoek naar titel",
    CompanyName: "Bedrijfsnaam",
    Industry: "Industrie",
    Subjects: "Onderwerpen",
    NewsTypes: "Nieuwstypen",
    ByDate: "Op datum",
    SelectCompanyName: "Selecteer bedrijfsnaam",
    SelectIndustry: "Selecteer Industrie",
    SelectSubjects: "Onderwerpen selecteren",
    SelectNewsType: "Selecteer het nieuwstype",
    Negative: "Negatief",
    Positive: "Positief",
  },
  Sanctions: {
    Potentialcompliance: "Er zijn potentiële compliancerisico's gedetecteerd", //检测到潜在合规风险
    SeachbuttonNo: "Er is niets nadeligs gedetecteerd over dit bedrijf", //未检测到任何与该公司相关的不良记录
    SeachbuttonYes:
      'Klik op de knop "Sancties zoeken" om meer sanctiegegevens te krijgen.', //要搜索更多制裁记录，请点击“搜索制裁”按钮。
    SearchSanctions: "Sancties zoeken", //搜索制裁
    ViewDetails: "Details bekijken", //查看详情
    Sanctions: "Sancties", //制裁
    Potentialcompliancerisks: "Potentiële compliancerisico's", //潜在合规风险
    IDInfo: "ID-info", //ID 信息
    IDType: "ID-type", //ID 类型
    IDDescription: "ID-beschrijving", //ID 描述
    SanctionList: "Sanctielijst", //制裁名单
    SanctionListInvolved: "Betrokken sanctielijst", //涉及的制裁名单
    StartDate: "Startdatum", //生效日期
    EndDate: "Einddatum", //结束日期
    SourceList: "Bronlijst", //来源名单
    SourceName: "Bronnaam", //来源名称
    ProfileNotes: "Profielnotities", //主体资料
    Link: "Link", //链接
    Name: "Naam", //名称
    AssociationList: "Associatielijst",
    AssociationID: "Verenigings-ID",
    AssociationType: "Associatietype",
  },
  CreditOpinion: {
    CreditAssessment: "Kredietbeoordeling",
    CreditAssessmentfromtheRelatedCompanies:
      "Kredietbeoordeling van de gerelateerde bedrijven",
    Year: "Jaar",
    CreditRating: "Kredietwaardigheid",
    LocalCreditScore: "Lokale kredietscore",
    ProbabilityofDefault: "Kans op wanbetaling",
    SolvencyIndex: "Solvabiliteitsindex",
    CreditLine: "Kredietlimiet",
    RiskIndicator: "Risico-indicator",
    RelatedCreditAssessment: "Gerelateerde kredietbeoordeling",
    CompanyName: "Bedrijfsnaam",
    CompanyID: "Bedrijfs-ID",
    Country: "Land",
    CompanyStatus: "Bedrijfsstatus",
    Relations: "Relaties",
    Cancel: "Annuleren", //取消
    Select: "Selecteren",
    CreditAssessmentMessage1:
      "Als de gegevens van het onderwerp onvoldoende zijn, of als u meer inzicht wilt krijgen in uw klant, biedt dit platform een uitgebreid overzicht van alle entiteiten die verband houden met het onderwerp. Dit omvat de aandeelhouders van het bedrijf van het onderwerp, gerelateerde bedrijven en meer.",
    CreditAssessmentMessage2:
      "Door u een breder perspectief te bieden, stelt dit platform u in staat beter geïnformeerde evaluaties te maken en een dieper inzicht in uw onderwerp te krijgen.",
    LocalCreditRating: "Lokale kredietwaardigheid",
    LocalCreditRatingDetail:
      "Gedreven door de kracht van big data is 3ARating een kwantitatief beoordelingssysteem voor particuliere bedrijven. Het is een samenwerking tussen 3ACredit en Creditreform Rating. Het ratingmodel is gebaseerd op een uitgebreide evaluatie van verschillende sleutelfactoren, waaronder niet-financiële factoren, financiële factoren, negatieve cijfers en sectorspecifieke overwegingen. Het beoordelingsmodel vertoont een indrukwekkende Gini-coëfficiënt, wat de robuustheid en betrouwbaarheid ervan aangeeft. 3ARating omvat een reeks ratings, van de hoogste rating, 3A1, tot de laagste ratingklasse, 3A19.",
    CreditScore: "Kredietscore",
    CreditScoreDetail:
      "Kredietscores worden berekend op een schaal van 1 tot 100, op basis van de kredietbeoordeling die is verkregen van de lokale autoriteiten. Een hogere score duidt op een betere kredietwaardigheid.",
    PossibilityofDefault: "Mogelijkheid van wanbetaling (PD)",
    PossibilityofDefaultDetail:
      "De Posibility of Default (PD) is een nuttig instrument voor risicobeoordeling, waarbij de nadruk ligt op de evaluatie van de liquiditeit op de korte termijn.",
    SolvencyIndexSI: "Solvabiliteitsindex (SI)",
    SolvencyIndexSIDetail:
      "De Solvency Index (SI) is een zeer effectieve en betrouwbare waarschuwingsindicator die een snelle beoordeling van de solvabiliteit van zakenpartners mogelijk maakt. Een hogere SI-waarde duidt op een hoger risico op wanbetaling door een klant. De SI varieert van 100, wat als een uitstekende beoordeling wordt beschouwd, tot 600, waarbij zeer negatieve kenmerken aanwezig zijn.",
    ExternalRating: "Externe beoordeling",
    DefaultProbability: "Standaardwaarschijnlijkheid (Pd1Year)",
    Rating: "3ARating (>=,<=)",
    PleaseSelectTheYeartoDisplay: "Selecteer het jaar dat u wilt weergeven",
    SelectUptoThreeYears: "Selecteer Maximaal drie jaar",
    HighRisk: "Hoog risico",
    Medium: "Medium",
    Moderate: "Gematigd",
    Average: "Gemiddeld",
    LowerThanAvg: "Lager dan gemiddeld",
    LowRisk: "Laag risico",
    CreditOpinion: "Kredietadvies",
  },
  IndustryStatistics: {
    SubjectCompany: "Onderwerp Bedrijf",
    Country: "Land",
    Compare: "Vergelijken",
    Industry: "Branche",
    CompanyType: "Bedrijfstype",
    CompanySize: "Bedrijfsgrootte",
    CompanyStatus: "Bedrijfsstatus",
    YearsinBusiness: "Jaren actief",
    CompanyRating: "Bedrijfsbeoordeling",
    Liquidity: "Kasstroomstatus",
    NoofcoinIndustry: "Aantal co. in Industrie",
    IndustryRating: "Industriebeoordeling",
    Profitability: "Winstgevendheid",
    Growth: "Groei",
    FinancialStructurt: "Financiële structuur",
    Solvency: "Solvabiliteit",
    SearchCountry: "Zoek land",
  },
  RatingAnalysis: {
    IndustyAnalysis: "Brancheanalyse",
    GeographicAnalysis: "Geografische analyse",
    CompanyTypeAnalysis: "Analyse bedrijfstype",
    BiusinessScaleAnalysis: "Analyse bedrijfsschaal",
    HistoryAnalysis: "Historische analyse",
    NormalDistribution: "Normale verdeling",
    SubjectCompany: "Onderwerpbedrijf",
    Probabilityofthesubjectratinginitsindustry:
      "Waarschijnlijkheid van beoordeling van het onderwerp in zijn branche",
    Maximum: "Maximaal 10%",
    Mean: "Gemiddelde",
    Average: "Gemiddelde",
    Minimum: "Minimaal 10%",
    RatingDistribution: "Beoordelingsverdeling",
    Revenue: "Omzet",
    Earning: "Winst",
    TotalAssets: "Totale activa",
    Subjectratinginitsindustrybyfinancialindicators:
      "Beoordeling van het onderwerp in zijn branche op basis van financiële indicatoren",
    Best: "Beste",
    Worst: "Slechtste",
    Rankingofsubject:
      "Rangschikking van de beoordeling van het onderwerp in de branche",
    Industy: "Branche",
    Percentilerank:
      "Percentielrangschikking: % bedrijven met een score gelijk aan of lager dan de beoordeling van het onderwerp",
    Historicaldevelopmentofsubject:
      "Historische ontwikkeling van de beoordeling van het onderwerp in zijn branche",
    IndustryAverage: "Gemiddelde in de branche",
    SubjectRatingChanges: "Wijzigingen in beoordeling van het onderwerp",
    CreditScore: "Kredietscore",
    NOofCompanies: "Aantal bedrijven",
    ofCompanies: "% van de bedrijven",
    CreditRating: "Kredietwaardigheid",
    CompanySize: "Bedrijfsgrootte",
    YearsinBusiness: "Jaren in het bedrijfsleven",
    SubjectsIndustryConcentrationAnalysis:
      "Analyse van de industriële concentratie van het onderwerp",
    GeographicdistributionofSubjectsratingintsindustry:
      "Geografische spreiding van de beoordeling van Subject in zijn branche",
    GeographicdistributioninSubjectindustry:
      "Geografische spreiding in de branche van het onderwerp",
    RatingDistributioninSubjectsLocation:
      "Beoordelingsverdeling op locatie van onderwerp",
    Ratinganalysisofcompanies:
      "Beoordelingsanalyse van bedrijven in dezelfde branche met verschillende jaren actief",
    Subjectsratinghistory:
      "De beoordelingsgeschiedenis van het onderwerp in vergelijking met leeftijdsgenoten met dezelfde geschiedenis",
    Ratingrankingofcompanieswithsamehistory:
      "Beoordelingsranglijst van bedrijven met dezelfde geschiedenis",
    Ratingstatistics:
      "Beoordelingsstatistieken van bedrijven met dezelfde jaren in bedrijf",
    Subjectratingcomparing:
      "Onderwerpbeoordeling in vergelijking met vergelijkbare bedrijven met de",
    Subjectratinginitsgroup: "Onderwerpbeoordeling in zijn groep",
    Analysisbasedonnature:
      "Analyse gebaseerd op de aard van bedrijven in de branche van het onderwerp",
    Subjectratingpositioninitscompanytype:
      "Onderwerpbeoordelingspositie in het bedrijfstype",
    Ratingstatisticsofcompanies:
      "Beoordelingsstatistieken van bedrijven in dezelfde branche",
    Ratinganalysisofcompanies:
      "Beoordelingsanalyse van bedrijven van verschillende grootte in dezelfde branche",
    Probabilityofsubjectrating:
      "Waarschijnlijkheid van onderwerpbeoordeling in zijn sector binnen zijn omvang",
    Subjectratingcomparingwithindustry:
      "Onderwerpbeoordeling in vergelijking met zijn collega's in zijn branche",
    RatingRankingofthecompanies:
      "Beoordeling Rangschikking van bedrijven van dezelfde omvang in dezelfde branche",
    Ratingstatisticsofcompanies:
      "Beoordelingsstatistieken van bedrijven van dezelfde omvang en dezelfde branche",
    Rank: "Rang",
    Rating: "rating",
    CompanyType: "Bedrijfstype",
  },
  CompetitiveAnalysis: {
    MarketPosition: "Marktpositie",
    Revenus: "Omzet",
    NetEarnings: "Nettowinst",
    NetAssets: "Nettoactiva",
    TotalAssets: "Totale activa",
    Employees: "Medewerkers",
    Mean: "Gemiddelde",
    Average: "Gemiddelde",
    Maximum: "Maximum (10%)",
    Worst: "Slechtste (10%)",
    Subjectcompany: "Onderwerpbedrijf",
    PerformanceComparison: "Prestatievergelijking",
    ProfitabilityRatios: "Winstgevendheidsratio's",
    Grossmargin: "Brutomarge",
    Returnonassets: "Rendement op activa",
    Returnonequity: "Rendement op eigen vermogen",
    OperatingRatios: "Operationele ratio's",
    Stockturnover: "Voorraadomloopsnelheid",
    Assetsturnover: "Activaomloopsnelheid",
    Currentassetturnoverrate: "Huidige omzet van activa",
    Collectionperiod: "Incassoperiode",
    GrowthRatios: "Groeiratio's",
    Totalassetsgrowthrate: "Groeipercentage totale activa",
    Salesgrowthrate: "Omzetgroeipercentage",
    Netprofitgrowthrate: "Groeipercentage nettowinst",
    StructuralRatios: "Structuurratio's",
    Debtratio: "Schuldratio",
    Quickratio: "Snelle ratio",
    Currentratio: "Huidige verhouding",
  },
  AccountCenterMenu: {
    SearchinSettings: "Zoeken in Instellingen", //在“设置”中搜索
    Account: "Account", //账户
    MyAccount: "Mijn account", //我的账户
    ContactInfo: "Contactgegevens", //联系信息
    AccountSecurity: "Accountbeveiliging", //账户安全
    OrganizationalManagement: "Organisatiebeheer", //组织管理
    UserGroup: "Gebruikersgroep", //用户组
    User: "Gebruiker", //用户
    Role: "Rol", //角色
    MyDatabase: "Mijn database", //我的数据库
    MyUsage: "Mijn gebruik", //我的使用情况
    CompaniesViewed: "Bekeken bedrijven", //查看过的公司
    ReportsDownloaded: "Gedownloade rapporten", //下载的报告
    ReportUpdatesOrdered: "Bestelde rapportupdates", //订购的报告更新
    BillingandPayment: "Facturering en betaling", //账单和付款
    BillRecords: "Rekeninggegevens", //账单记录
    PaymentRecords: "Betalingsgegevens", //付款记录
    CreditDeductions: "Creditaftrek", //信用扣款
    InvoicesDownloaded: "Gedownloade facturen", //下载的发票
    UserSettings: "Gebruikersinstellingen", //用户设置
    Messages: "Berichten", //消息
    Notifications: "Meldingen", //通知
    HelpCenter: "Helpcentrum", //帮助中心
    FAQ: "Veelgestelde vragen", //常见问题
    Privacy: "Privacy", //隐私
    Terms: "Voorwaarden", //条款
    ReportIssues: "Problemen melden", //报告问题
    UserGuide: "Gebruikershandleiding", //用户指南
    AboutCSI: "Over CSI", //关于CSI
  },
  MyAccount: {
    Logintime: "Inlogtijd", //登录时间
    SignOut: "Afmelden", //退出
    DeleteAccount: "Account verwijderen", //删除账户
    AccountID: "Account-ID", //账户ID
    Enteranewaddress: "Voer een nieuw e-mailadres in", //输入新的电邮
    EnterVerificationCode: "Voer verificatiecode in", //输入验证码
    SendverificationCode: "Verificatiecode verzenden", //发送验证码
    Password: "Wachtwoord", //密码
    Originalpassword: "Oorspronkelijk wachtwoord", //原始密码
    Newpassword: "Nieuw wachtwoord", //新密码
    Confirmnewpassword: "Bevestig nieuw wachtwoord", //确认新密码
    AccountOwnership: "Accounteigendom", //账户所有权
    IndividualAccount: "Individueel account", //个人账户
    GroupAccount: "Groepsaccount", //集团账户
    Organizationname: "Organisatienaam", //机构名称
    CountryRegion: "Land/Regio", //国家/地区
    Address: "Adres", //地址
    City: "Plaats", //城市
    ZipCode: "Postcode", //邮政编码
    FirstName: "Voornaam", //名字
    LastName: "Achternaam", //姓氏
    PhoneNumber: "Telefoonnummer", //电话号码
    Email: "E-mailadres", //更改
    Change: "Wijzigen", //更改
    Save: "Opslaan", //保存
    Cancel: "Annuleren", //取消
    LastLogin: "Laatste aanmelding", //Last Login
    RecentLogin: "Recente aanmelding", //登录尝试次数
    AverageLoginTime: "Gemiddelde inlogtijd", //平均登录时间
    TotalLoginAttempts: "Totaal aantal inlogpogingen", //登录尝试次数
    Registrationtime: "Registratietijd",
    Role: "Rol",
    Administrator: "Beheerder",
    Enterpriseusers: "Zakelijke gebruikers",
    EditImage: "Afbeelding bewerken",
    DeleteImage: "Afbeelding verwijderen",
  },
  ContactInfo: {
    ContactInfo: "Contactgegevens",
    FirstName: "Voornaam",
    LastName: "Achternaam",
    PhoneNumber: "Telefoonnummer",
    Email: "E-mailadres",
    CountryRegion: "Land/Regio",
    AddressLine: "Adresregel",
    City: "Plaats",
    ZipCode: "Postcode",
    Alternativecontactperson: "Alternatieve contactpersoon",
    Setascontactperson: "Instellen als contactpersoon",
    Edit: "Bewerken",
  },
  AccountSecurity: {
    Setupmysecurityquestions: "Stel mijn beveiligingsvragen in",
    Pleasechooseaquestion: "Kies een vraag",
    Pleaseentertheanswertothequestion: "Voer het antwoord op de vraag in",
    SessionTimeoutAutomaticLogoutSettings:
      "Sessie-time-out: Instellingen voor automatisch uitloggen",
    Thesystemwillautomatically:
      "Het systeem logt u automatisch uit na een periode van inactiviteit. De standaardtime-out is ingesteld op 5 minuten, maar u kunt deze duur naar wens aanpassen.",
  },
  MyDatabase: {
    TotalNumberofCompaniesSearched: "Totaal aantal gezochte bedrijven",
    TotalNumberofCompaniesCollected: "Totaal aantal verzamelde bedrijven",
    TotalNumberofUpdateReportsOrdered: "Totaal aantal bestelde updaterapporten",
    Date: "Datum",
    UserName: "Gebruikersnaam",
    CompanyName: "Bedrijfsnaam",
    Status: "Status",
    UsageType: "Gebruikstype",
    Entercompanyname: "Voer de bedrijfsnaam in",
    Download: "Downloaden",
  },
  OrganizationalManagement: {
    GroupName: "Groepsnaam",
    ParentGroupName: "Naam bovenliggende groep",
    Organization: "Organisatie",
    GroupID: "Groeps-ID",
    GroupStatus: "Groepsstatus",
    Operation: "Bewerking",
    NewlyBuilt: "Nieuw aangemaakt",
    UserAccount: "Gebruikersaccount",
    Role: "Rol",
    AccountStatus: "Accountstatus",
    RoleName: "Rolnaam",
    Position: "Positie",
    RoleStatus: "Rolstatus",
    Valid: "Geldig",
    Invalid: "Ongeldig",
    PermissionSettings: "Instellingen",
    ShowMore: "Meer weergeven",
    Search: "Zoeken",
    Cancel: "Annuleren",
    Confirm: "Bevestig",
    NewGroup: "NieuweGroep",
    EnterGroupName: "Voer groepsnaam in",
    NumberofGroups: "Aantal groepen",
    Groups: "Groepen",
    Roles: "Rollen",
    NewRoles: "Nieuwe rollen",
    EnterNewRole: "Voer een nieuwe rol in",
    Users: "Gebruikers",
    EnterUserName: "Voer gebruikersnaam in",
  },
  BillingandPayment: {
    TotalNumberofOrders: "Totaal aantal bestellingen",
    TotalPaymentAmount: "Totaal betaald bedrag",
    TotalUsedCredits: "Totaal gebruikte credits",
    Date: "Datum",
    UserAccount: "Gebruikersaccount",
    CompanyName: "Bedrijfsnaam",
    OrderNo: "Ordernummer",
    OrderType: "Besteltype",
    OrderStatus: "Bestelstatus",
    Download: "Downloaden",
    PaymentAmount: "Betaalbedrag",
    Contactus: "Contact",
    DownloadInvoice: "Factuur downloaden",
    CreditUsage: "Credit Gebruik",
    ReportOrderStatus: "Orderstatus rapporteren",
    CompanyID: "Bedrijfs-ID",
    CountryRegion: "Land/Regio",
    AddressLine: "Adresregel",
    City: "Plaats",
    ZipCode: "Postcode",
    FirstName: "Voornaam",
    LastName: "Achternaam",
    PhoneNumber: "Telefoonnummer",
    Email: "E-mailadres",
    BankAccountHolderName: "Naam bankrekeninghouder",
    BeneficiaryBankName: "Naam begunstigde",
    SWIFTCODE: "SWIFT-CODE",
    AccountNumber: "Rekeningnummer",
    BeneficiaryBankAddress: "Adres bank begunstigde",
    ABA: "ABA (routingnummer)",
    IBANnumber: "IBAN-nummer",
    StartingMonth: "Startmaand",
    EndMonth: "Einde maand",
    InvoiceInfo: "Factuurgegevens",
  },
  UserSettings: {
    LanguageandLocation: "Taal en locatie",
    Language: "Taal",
    Selectyourpreferedlanguage: "Selecteer uw voorkeurstaal",
    Location: "Locatie",
    Selectyourlocation: "Selecteer uw locatie",
    NotificationSetting: "Meldingsinstellingen",
    EmailNotification: "E-mailmeldingen",
    ServiceUpdates: "Service-updates",
    CompanyNews: "Bedrijfsnieuws",
  },
  AddCredit: {
    Customizeyourplan: "Pas uw plan aan zoals u dat wilt",
    Silver: "Zilver",
    Gold: "Goud",
    Enterpris: "Ondernemingen",
    Credit: "Krediet",
    Remaining: "Resterende {0} punten",
    Usermonth: "gebruiker/maand",
    Useryear: "gebruiker/jaar",
    PaidMonthlyRenews:
      "Maandelijks betaald, geen automatische verlenging nodig",
    PaidAnnuallyRenews: "Jaarlijks betaald, geen automatische verlenging nodig",
    ForFullSupport: "voor volledige ondersteuning van uw behoeften",
    Each: "elk",
    CreditsCharged:
      "Tegoeden die op uw account in rekening worden gebracht, verlopen nooit zolang uw account actief blijft.",
    PaidMonthly: "maandelijks betaald",
    PaidAnnually: "jaarlijks betaald",
    BuyNow: "koop nu",
    ContactNow: "neem nu contact op",
    SearchCompanies:
      "Zoek bedrijven en krijg direct toegang tot bedrijfsgegevens, waaronder:",
    EverythinginSilverPackage: "Alles in Zilverpakket, plus",
    CreditsCanbeUsed:
      "Credits kunnen worden gebruikt voor meer datadiensten, waaronder de volgende",
    UnlimitedAdvancedSearch: "Onbeperkt geavanceerd zoeken",
    ViewCompanyProfile: "Bekijk bedrijfsprofiel",
    CompanyOwnershipStructure: "Eigendomsstructuur van het bedrijf",
    CompanyFamilyTree: "Stamboom van het bedrijf",
    Companymanagement: "Bedrijfsleiding",
    CompanyContactsinfo: "Bedrijfscontactgegevens",
    BusinessActivities: "Zakelijke activiteiten",
    IndustryBasics: "Basisprincipes van de industrie",
    ImportExportRecords: "Import- en exportrecords",
    CompanyPublications: "Bedrijfspublicaties",
    CompanyNews: "Bedrijfsnieuws",
    DownloadOnlineReport: "Online rapport downloaden",
    ManagementDetails: "Beheerdetails",
    ShareholderPenetration: "Aandeelhouderspenetratie (UBO)",
    Financialinfo: "Financiële informatie",
    FinancialAnalysis: "Financiële analyse",
    CreditAssessment: "Kredietbeoordeling",
    IndustryAnalysis: "Industrie analyse",
    MarketAnalysis: "Marktanalyse",
    SupplyChaininfo: "Informatie over de toeleveringsketen",
    CheckSanctions: "Controleer sancties",
    CompanyComparison: "Bedrijfsvergelijking",
    DataExport: "Gegevens exporteren",
    MonitoringService: "Bewakingsdienst",
    DiscountForFreshUpdateReports: "Korting voor nieuwe updaterapporten",
    SearchCompany: "Zoek bedrijf",
    SearchLeads: "Zoek leads",
    SearchTrade: "Zoek handel",
    SearchPeople: "Zoek mensen",
    SearchCountry: "Zoek land",
    SearchNews: "Zoek Nieuws",
    SearchSanction: "Zoek sanctie",
    DataServices: "Datadiensten",
    APIPlans: "API-abonnementen",
    VolumeDiscounts: "Volumekortingen",
    GroupAccountsWithMultipleUsers: "Groepsaccounts met meerdere gebruikers",
    CustomizedPlans: "Aangepaste plannen",
    FreshInvestigatedCreditReportsWorldwide:
      "Fresh onderzocht kredietrapporten wereldwijd",
    BusinessMonitoringServices: "Bedrijfsmonitoringdiensten",
    BusinessProcessVerificationServices:
      "Verificatiediensten voor bedrijfsprocessen",
    VendorComplianceReports: "Nalevingsrapporten van leveranciers",
    MarketResearch: "Marktonderzoek",
    More: "Meer…",
    Contactus: "Neem contact met ons op",
    PaymentMethod: "Betaalmethode",
    CreditCardNumber: "Creditcardnummer",
    EnterCardNumber: "Voer kaartnummer in",
    ExpirationDate: "Vervaldatum",
    Fullnameoncard: "Volledige naam op kaart",
    EnterFullname: "Voer volledige naam in",
    EnterProvinceState: "Voer provincie/staat in",
    CVCCode: "CVC-code",
    EnterCVCCode: "CVC-code invoeren",
    TotalPurchase: "Totale aankoop",
    Agree1: "Door op 'Verzenden' te klikken, gaat u akkoord met de ",
    Agree2: "CSI-serviceovereenkomst en privacy.",
    Submit: "Verzenden",
    Month: "Maand",
    Year: "Jaar",
    Country: "Land",
    ProvinceState: "Provincie/Staat",
    Cancel: "Annuleren",
    IncorrectCreditCardNumberformat: "Onjuist creditcardnummerformaat",
    IncorrectExpMonthformat: "Onjuiste indeling Exp.Maand",
    IncorrectExpYearformat: "Onjuiste notatie van Exp.Jaar",
    IncorrectFullNameformat: "Onjuiste volledige naamnotatie",
    IncorrectCountryformat: "Onjuist landformaat",
    IncorrectProvinceStateformat: "Onjuiste indeling van provincie/staat",
    IncorrectCVCCodeformat: "Onjuist CVC-codeformaat",
  },
  ReportIssues: {
    Whattypeoferrorsyouarereporting: "Welke soorten fouten meldt u?",
    Tellusmoreaboutyourproblems: "Vertel ons meer over uw problemen.",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:
      "Wilt u een screenshot of een bestand met betrekking tot uw probleem meesturen?",
    Fillinyourcontactinformation: "Vul uw contactgegevens in",
    FirstName: "Voornaam",
    LastName: "Achternaam",
    PhoneNumber: "Telefoonnummer",
    Email: "E-mailadres",
    Edit: "Bewerken",
  },
  //Risk Scan
  RiskScan: {
    RiskScan: "Risk Scan",
    RiskScanInfo:
      " is uw alles-in-één platform voor uitgebreide bedrijfsrisico-informatie. We bieden gedetailleerde analyses voor elke belangrijke risicocategorie om uw zakelijke beslissingen te waarborgen.",
    LegalRisk: "Juridisch risico",
    LegalRiskInfo: "controleer de legitimiteit van het bedrijf.",
    OrganizationalRisk: "Organisatorisch risico",
    OrganizationalRiskInfo:
      "stabiliteit van het management, complexiteit van de bedrijfsstructuur en transparantie van het eigendom.",
    OperationalRisk: "Operationeel risico",
    OperationalRiskInfo:
      "kwetsbaarheden in de toeleveringsketen, operationele status en geopolitieke blootstelling.",
    FinancialRisk: "Financieel risico",
    FinancialPerformanceRiskInfo:
      "winstgevendheidstrends, liquiditeitsproblemen en de gezondheid van de balans.",
    CreditRisk: "Kredietrisico",
    CreditRiskInfo:
      "kredietwaardigheid, betalings-verleden en kans op wanbetaling.",
    ComplianceRisk: "Compliancerisico",
    ComplianceRiskInfo:
      "naleving van sancties, AML-regelgeving en branchespecifieke wetten",
    SustainabilityRisk: "Duurzaamheidsrisico",
    SustainabilityRiskInfo:
      "ESG-factoren (milieu, maatschappij, bestuur) en reputatieschade.",
    IndustryRisk: "Brancherisico",
    IndustryRiskInfo:
      "beoordeelt de stabiliteit en vooruitzichten van de gehele sector van een bedrijf.",
    LetBegin: "Laten we beginnen",
    AddcompaniesfromSearchResult:
      "Bedrijven toevoegen vanuit het zoekresultaat",
    AddcompaniesfromMyDatabase: "Bedrijven toevoegen vanuit Mijn Database",
    Addcompaniesbyuploadmyownlist:
      "Bedrijven toevoegen door mijn eigen lijst te uploaden",
    Uploadyourlistofcompanies:
      "Upload uw lijst met bedrijven en Risk Scan voorziet u direct van actuele gegevens voor elke entiteit. Met uitgebreide risicobeoordelingen in acht risicocategorieën transformeert Risk Scan uw risicomanagement van reactief naar een proactief strategisch voordeel.",
    Select: "Selecteer",
    Upload: "Uploaden",
    Cancel: "Annuleren",
    Confirm: "Bevestig",
    UploadFiles: "Bestanden uploaden",
    PleaseuploadyourfileinCVSformat: "Upload uw bestand in xlsx-formaat.",
    Downloadxlsxtemplate: "xlsx-sjabloon downloaden",
    Xcompanieswereuploadedsucessfuly: "{0} bedrijven zijn succesvol geüpload.",
    Xcompanieswereidentifiedsucessfuly:
      "{0} bedrijven werden succesvol geïdentificeerd.",
    Xcompanieswerenotmatched: "{0} bedrijven werden niet gematched.",
    Uploadingfilefailed:
      "Uploaden van bestand mislukt. Gebruik het sjabloon en probeer het opnieuw.",
    Uploading: "Uploaden",
    Uploadwithamaximumfilesizeof1M:
      "(Er kunnen maximaal 100 gegevens tegelijk worden geüpload, met een maximale bestandsgrootte van 1 MB.)",
    Tryagain: "Probeer het opnieuw",
    Theuploadedonlyxlsx:
      "Het geüploade bestand mag alleen in XLS/XLSX-formaat zijn",
    Scanning: "Scannen",
    RiskScanning: "Risicoscan",
    Youhaveselectedatotalof: "U heeft",
    Tostartriskscanning:
      'bedrijven geselecteerd. Klik op "Bevestigen" om te beginnen met scannen.',
    Datascanningisinprogress: "Het scannen van de gegevens is bezig...",
    LastUpdate: "Laatste update",
    Selectdate: "Selecteer datum",
    UpdateStatus: "Update status",
    ClearAll: "Alles wissen",
    ALL: "Alles",
    Updated: "Bijgewerkt",
    Notupdated: "Niet bijgewerkt",
    HistoricalData: "Historische gegevens",
    Selectrisklevel: "Selecteer het risiconiveau",
    Low: "Laag",
    Average: "Gemiddeld",
    Caution: "Voorzichtigheid",
    NotRated: "Niet beoordeeld",
    Reselect: "Opnieuw selecteren",
    HistoricalRecords: "Historische archieven",
    DownloadReport: "Rapport downloaden",
    SearchLeads: "Zoek prospects",
    CompanyName: "Bedrijfsnaam",
    CompanyID: "Ondernemings-ID",
    CompanyType: "Bedrijfstype",
    RegistrationDate: "Registratiedatum",
    RegistrationStatus: "Registratiestatus",
    Listed: "beursgenoteerd",
    LegalStatus: "Rechtspositie",
    NoofShareholders: "Aantal aandeelhouders",
    ShareholdingLayers: "Aandeelhouder niveaus",
    NoofCorporateShareholders: "Aantal aandeelhouders van ondernemingen",
    NoofNatualPersonShareholders:
      "Aantal natuurlijke personen als aandeelhouders",
    RelatedCompanies: "Gerelateerde bedrijven",
    OrganizationalStatus: "Organisatiestatus",
    OperatingAddress: "Bedrijfsadres",
    IndustryCode: "Industriecode",
    BusinessActivities: "Bedrijfsactiviteiten",
    NoofEmployees: "Aantal werknemers",
    Management: "Management",
    CurrentOperations: "Huidige activiteiten",
    Revenue: "omzet",
    Assests: "Activa",
    ProfitLoss: "Winst/verlies",
    Liquidity: "Liquiditeit",
    Growth: "groei",
    Performance: "Bedrijfsprestaties",
    CreditRating: "Krediet rating",
    CreditScore: "Kredietscore",
    PausibilityofDefault: "Pausibiliteit van wanbetaling (PD)",
    SolvencyIndex: "Solvabiliteitsindex",
    DebtCollection: "incasso",
    CreditOpinion: "Kredietmening",
    CompanySanction: "Bedrijfssancties",
    ProductSanction: "Productsanctie",
    ExportControl: "Exportcontrole",
    AntiCorruptionAntiBribery: "Anti-corruptie en anti-omkoping",
    Litigations: "Rechtszaken",
    NegativeNews: "Negatief nieuws",
    ESGScore: "ESG-score",
    YearsinBusiness: "Jaren in het bedrijfsleven",
    Competitiveness: "Concurrentievermogen",
    WorkingCapital: "Marktrisico",
    FinancialStructure: "Leveranciersketen Index",
    Industrystatus: "Industriestatus",
    IndustryOutlook: "Industrievooruitzichten",
    NoofCompanies: "Aantal bedrijven",
    IndustryRanking: "Industrie rangschikking",
    IndustryConcentration: "Industrie BBP %",
    IndustryCompetitiveness: "Concurrentievermogen van de industrie",
    IndustryDevelopment: "Industriële ontwikkeling",
    Legal: "Juridisch",
    Organizational: "Organisatorisch",
    Operational: "Operationeel",
    Financial: "Financieel",
    Credit: "Credit",
    Compliance: "Naleving",
    Sustainability: "Duurzaamheid",
    Industry: "Industrie",
    ScanDate: "Scandatum",
    Updating: "Bijwerken",
    ScanHistoricalData: "Historische gegevens scannen",
    StartDate: "Startdatum",
    EndDate: "Einddatum",
    Download: "Downloaden",
    Entercompanyname: "Bedrijfsnaam invoeren",
  },
  //Data Management
  DataManagement: {
    DataManagement: "gegevensbeheer",
    AllCompanies: "Alle bedrijven",
    CompaniesViewed: "Bedrijven bekeken",
    CompaniesCollected: "Bedrijven verzameld",
    CompaniesUploaded: "Bedrijven geüpload",
    MyPortfolio: "Mijn portefeuille",
    Date: "Datum",
    CompanyName: "Bedrijfsnaam",
    Country: "Land",
    CompanyType: "Bedrijfstype",
    CompanyStatus: "Bedrijfsstatus",
    DQI: "DQI",
    Download: "Download",
    Addcompanies: "Bedrijven toevoegen",
    Filter: "Filter",
    Selectcountry: "Selecteer land",
    Selectindustry: "Selecteer branche",
    Selectcompanytype: "Selecteer bedrijfstype",
    Selectcompanysize: "Selecteer bedrijfsgrootte",
    Selectcompanystatus: "Selecteer bedrijfsstatus",
    Selectlistedcompanies: "Selecteer beursgenoteerde bedrijven",
    Selectcompanyyearsinbusiness: "Selecteer bedrijfsjaren in bedrijf",
    Industry: "Industrie",
    CompanySize: "Bedrijfsgrootte",
    Listed: "Genoteerde",
    CompanyAge: "Bedrijfsleeftijd",
    SelectYear: "Selecteer jaar",
    SelectQuarter: "Selecteer kwartaal",
    SelectMonth: "Selecteer maand",
    Reset: "Reset",
    Search: "Zoekopdracht",
    MyDatabase: "Mijn database",
    Locations: "Locaties",
    YearsinBusiness: "Jaren in het bedrijf",
    CompanyDQI: "DQI",
    RiskScan: "Risico Scan",
    CreditAssessment: "Kredietbeoordeling",
    Uptodate: "Up-to-date",
    Average: "Gemiddeld",
    Insufficient: "Onvoldoende",
    Good: "Goed",
    Caution: "Voorzichtig",
    Unknown: "Onbekend",
    CompanyTag: "Bedrijfstag",
    Remove: "Verwijderen",
    Uploaded: "Geüpload",
    Identified: "Geïdentificeerd",
    Notmatched: "Niet overeenkomend",
    UploadCompanies: "Bedrijven uploaden",
    Match: "Overeenkomst",
    Delete: "Verwijderen",
    OnlineMatching: "Online matching",
    Identifythecompanywithmanualcheck:
      "Identificeer het bedrijf met handmatige controle",
    Identifyacompanymanually: "Een bedrijf handmatig identificeren",
    Pleaseprovideanyrelevantinformation:
      "Geef relevante informatie die de zoekresultaten kan verbeteren. Onze data-analist koppelt u aan het meest geschikte bedrijf.",
    RegistrationID: "Bedrijfs-ID",
    StateProvince: "Staat/provincie",
    Address: "Adres",
    Otherinformation: "Overige informatie",
    Submit: "Indienen",
    Cancel: "Annuleren",
    Confirm: "Bevestig",
    EnterRegistrationID: "Voer uw registratie-ID in",
    EnterAddress: "Voer het adres in",
    EnterInformation: "Voer gegevens in",
    User: "Gebruiker",
    Task: "Taak",
    NoofCompanies: "Aantal bedrijven",
    Entercompanyname: "Voer de bedrijfsnaam in",
    SaveYourPortfolio: "Sla uw portefeuille op",
    PortfolioName: "Portefeuillenaam",
    Notes: "Notities",
    Edit: "Bewerken",
    EnterPortfolioName: "Voer de portfolionaam in",
    EnterUserName: "Gebruiker invoeren",
    SelectTaskName: "Taak selecteren",
    EnterNotes: "Notities invoeren",
    StartingMonth: "Startmaand",
    EndMonth: "Einde maand",
  },
  ...nlLocale,
};

export default nl;
